import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";

import Home from "./pages/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ProductDetail from "./pages/ProductDetail";
import ProductsPage from "./pages/Products";
import ClearnPage from "./pages/Clearn";
import PricePage from "./pages/Price";
import BlogNewPostPage from "./pages/BlogNewPost";
import BlogPosts from "./pages/BlogPosts";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { Provider } from "react-redux";
import BlogPost from "./pages/BlogPost";
import GoFilterPage from "./pages/GoFilter";
import PromoPopup from "./components/PromoPopup";

function App() {
  return (
    <Router>
      <PromoPopup />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product-detail/:id" element={<ProductDetail />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/clearn" element={<ClearnPage />} />
        <Route path="/price" element={<PricePage />} />
        <Route path="/blog/posts" element={<BlogPosts />} />
        <Route path="/blog/post/:slug" element={<BlogPost />} />
        <Route path="/google.com" element={<GoFilterPage />} />
        <Route
          path="/new-post"
          element={
            <ProtectedRoute>
              <BlogNewPostPage />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
